// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-user-content{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.CmtAuth{
width: 90%;
border: grey 2px solid;
border-radius: 10px;
}
.lblCmtAuth{
    position: absolute;
  left: 30px;
  top: -12px;
  color: gray;
}
.auth-modal
{
  width: 99% !important;
}
.denied{
    width: 99% !important;
    /* border: 2px solid rgb(235, 42, 42) !important */
}
.head-card-users.denied{
    background-color: rgb(235, 42, 42) !important;
    width: 100% !important;
}
.authorize{
    width: 99% !important;
    /* border: 2px solid rgb(30, 172, 30) !important */
}
.head-card-users.authorize{
    background-color: rgb(30, 172, 30) !important;
    width: 100% !important;
}
.cont-info-modal-delete{
    position: relative;
    display: block;
    width: 95%;
    height: 95%;
}
.cont-message-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}
.txt-message-modal-delete{
    font-size: large;
    color: rgb(235, 42, 42);
    letter-spacing: 1px;
}
.cont-user-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 40%;
    justify-content: center;
    align-items: center;
}
.txt-user-modal-delete-buzon{
    font-size: medium;
    color: rgb(51, 51, 51);
    letter-spacing: 1px;
}
.cont-btn-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/styles/ModalReqAuth.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;AACA,UAAU;AACV,sBAAsB;AACtB,mBAAmB;AACnB;AACA;IACI,kBAAkB;EACpB,UAAU;EACV,UAAU;EACV,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;AACA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;AACA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".modal-user-content{\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.CmtAuth{\nwidth: 90%;\nborder: grey 2px solid;\nborder-radius: 10px;\n}\n.lblCmtAuth{\n    position: absolute;\n  left: 30px;\n  top: -12px;\n  color: gray;\n}\n.auth-modal\n{\n  width: 99% !important;\n}\n.denied{\n    width: 99% !important;\n    /* border: 2px solid rgb(235, 42, 42) !important */\n}\n.head-card-users.denied{\n    background-color: rgb(235, 42, 42) !important;\n    width: 100% !important;\n}\n.authorize{\n    width: 99% !important;\n    /* border: 2px solid rgb(30, 172, 30) !important */\n}\n.head-card-users.authorize{\n    background-color: rgb(30, 172, 30) !important;\n    width: 100% !important;\n}\n.cont-info-modal-delete{\n    position: relative;\n    display: block;\n    width: 95%;\n    height: 95%;\n}\n.cont-message-modal-delete{\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 30%;\n    justify-content: center;\n    align-items: center;\n}\n.txt-message-modal-delete{\n    font-size: large;\n    color: rgb(235, 42, 42);\n    letter-spacing: 1px;\n}\n.cont-user-modal-delete{\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 40%;\n    justify-content: center;\n    align-items: center;\n}\n.txt-user-modal-delete-buzon{\n    font-size: medium;\n    color: rgb(51, 51, 51);\n    letter-spacing: 1px;\n}\n.cont-btn-modal-delete{\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 30%;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
